import React from 'react';
import { Share2, Leaf } from 'lucide-react';
import { toast } from 'sonner';
interface TopBarProps {
  activeTab: 'tree' | 'stories';
  setActiveTab: (tab: 'tree' | 'stories') => void;
}
export function TopBar({
  activeTab,
  setActiveTab
}: TopBarProps) {
  const handleShare = () => {
    const fakeUrl = 'https://wa.me/?text=Explore%20our%20FamilyTree%3A%20https%3A%2F%2Ffamilytree.app%2Fshare%2F123';
    navigator.clipboard.writeText(fakeUrl);
    toast.success('Link copied — share on WhatsApp', {
      style: {
        background: '#2a201c',
        color: '#f5ede1',
        border: '1px solid #3d302a'
      }
    });
  };
  return <header className="absolute top-0 left-0 right-0 z-40 flex items-center justify-between px-6 py-4 bg-gradient-to-b from-warm-bg/90 to-transparent pointer-events-none" data-id="element-107">
      <div className="flex items-center gap-2 pointer-events-auto" data-id="element-108">
        <div className="w-8 h-8 rounded-full bg-warm-surface flex items-center justify-center border border-warm-border" data-id="element-109">
          <Leaf className="w-4 h-4 text-warm-cyan" data-id="element-110" />
        </div>
        <h1 className="text-xl font-serif text-warm-text tracking-wide" data-id="element-111">
          FamilyTree
        </h1>
      </div>

      {/* Desktop Tabs */}
      <div className="hidden md:flex items-center gap-1 bg-warm-surface/80 backdrop-blur-md p-1 rounded-full border border-warm-border pointer-events-auto" data-id="element-112">
        {(['tree', 'stories'] as const).map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`px-6 py-1.5 rounded-full text-sm font-medium transition-colors ${activeTab === tab ? 'bg-warm-border text-warm-text' : 'text-warm-muted hover:text-warm-text'}`} data-id="element-113">
            {tab.charAt(0).toUpperCase() + tab.slice(1)}
          </button>)}
      </div>

      <button onClick={handleShare} className="pointer-events-auto flex items-center gap-2 px-4 py-2 rounded-full bg-warm-surface border border-warm-border text-warm-cyan hover:bg-warm-border transition-colors text-sm font-medium" data-id="element-114">
        <Share2 className="w-4 h-4" data-id="element-115" />
        <span className="hidden sm:inline" data-id="element-116">Share Family Link</span>
      </button>
    </header>;
}